<div class="loader-inner">
  <div class="container">
    <div class="spinner-container spacing-top-40">
      <app-spinner></app-spinner>
    </div>
    <!-- <div class="wrapper">
      <div class="zip-spinner">
        <div class="spin spin--1"></div>
        <div class="spin spin--2"></div>
        <div class="spin spin--3"></div>
        <div class="spin spin--4"></div>
      </div>
    </div> -->
  </div>
</div>
